import Button from '../../button'
import { FormattedMessage } from 'react-intl'
import { useState } from 'react'
import { shape, node, func, object } from 'prop-types'
import IconFilters from '../../../atoms/icons/filters-icon'
import IconClose from '../../../atoms/icons/x-icon'
import {
	Container,
	ActionsWrapper,
	ActionsInnerWrapper,
	Filters,
	ActiveFilters,
	TitleFilters,
	ButtonClose,
	SwipeableDrawer,
	ButtonOpener,
} from './filters-drawer.styled'
import { useTheme } from '@mui/system'
import useMediaQuery from '@mui/material/useMediaQuery'

const FiltersDrawer = ({
	buttonLabel,
	buttonResetLabel,
	buttonApplyLabel,
	buttonProps,
	buttonCloseProps,
	drawerProps,
	filtersProps,
	titleFilters,
	onResetFilters,
	activeFilterProps,
}) => {
	const [openFilterDialog, setOpenFilterDialog] = useState(false)
	const theme = useTheme()
	const smUp = useMediaQuery(theme.breakpoints.up('sm'))

	return (
		<>
			<ButtonOpener
				onClick={() => setOpenFilterDialog(true)}
				variant="textNoLink"
				StartIcon={() => <IconFilters fontSize="button" />}
				{...buttonProps}
			>
				{buttonLabel}
			</ButtonOpener>
			<SwipeableDrawer
				open={openFilterDialog}
				onOpen={() => {}}
				onClose={() => setOpenFilterDialog(false)}
				anchor={smUp ? 'right' : 'bottom'}
				disableSwipeToOpen
				{...drawerProps}
			>
				<Container>
					<ButtonClose
						variant="icon"
						Icon={IconClose}
						iconProps={{ fontSize: 'medium' }}
						className="iconClose"
						color="black"
						onClick={() => setOpenFilterDialog(false)}
						{...buttonCloseProps}
					/>
					<TitleFilters variant="h1">{titleFilters}</TitleFilters>
					<ActiveFilters
						onDeleteActiveFilter={filtersProps.onDeleteActiveFilter}
						items={filtersProps.items}
						{...activeFilterProps}
					/>
					<Filters
						showActiveFilters={false}
						showMoreButton={false}
						exclusive={true}
						defaultExpanded={null}
						{...filtersProps}
					/>
					<ActionsWrapper>
						<ActionsInnerWrapper>
							<Button variant="outlined" color="primary" onClick={onResetFilters}>
								{buttonResetLabel}
							</Button>
							<Button color="primary" onClick={() => setOpenFilterDialog(false)}>
								{buttonApplyLabel}
							</Button>
						</ActionsInnerWrapper>
					</ActionsWrapper>
				</Container>
			</SwipeableDrawer>
		</>
	)
}

FiltersDrawer.defaultProps = {
	buttonLabel: <FormattedMessage id="filter_link_opener" />,
	titleFilters: <FormattedMessage id="filter_title_drawer" />,
	titleSortables: <FormattedMessage id="filters_sort_by" />,
	buttonResetLabel: <FormattedMessage id="filter_reset_label" />,
	buttonApplyLabel: <FormattedMessage id="filter_apply_label" />,
	filtersProps: {
		...Filters.defaultProps,
		maxFiltersCount: 1000,
	},
}

FiltersDrawer.propTypes = {
	buttonLabel: node,
	buttonResetLabel: node,
	buttonApplyLabel: node,
	buttonProps: shape(Button.propTypes),
	buttonCloseProps: shape(Button.propTypes),
	drawerProps: shape(SwipeableDrawer.propTypes),
	filtersProps: shape(Filters.propTypes),
	titleFilters: node,
	titleSortables: node,
	onResetFilters: func,
	activeFilterProps: object,
}

export default FiltersDrawer
